import { useNavigate } from 'react-router-dom'

import FormularioMovimientoBodega from '../../components/bodega/FormularioMovimientoBodega'
import ModalMensaje from '../../components/ui/ModalMensaje'
import { useEmpresa } from '../../context/EmpresaContext'
import { useModalMensaje } from '../../hooks/useModalMensaje'

function NuevaSalidaBodega() {
  const navigate = useNavigate()
  const { empresaActual } = useEmpresa()
  const { modal, abrirModal, cerrarModal } = useModalMensaje()

  const esConsulta = empresaActual?.rol === 'consulta'

  if (esConsulta) {
    return (
      <div className="rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">
        <h3 className="text-lg font-bold text-slate-900">
          Sin permisos
        </h3>

        <p className="mt-2 text-slate-500">
          Tu perfil no tiene permisos para registrar salidas de
          bodega.
        </p>
      </div>
    )
  }

  const alGuardar = () => {
    abrirModal({
      tipo: 'success',
      titulo: 'Salida registrada',
      mensaje: 'La salida de bodega fue registrada correctamente.',
      onAceptar: () => {
        cerrarModal()
        navigate('/bodega/movimientos', {
          state: { recargar: true },
        })
      },
    })
  }

  return (
    <>
      <FormularioMovimientoBodega
        tipoMovimiento="SALIDA"
        titulo="Nueva salida"
        subtitulo="Registra la salida de productos desde una bodega."
        onGuardado={alGuardar}
        onCancelar={() => navigate('/bodega/movimientos')}
      />

      <ModalMensaje {...modal} />
    </>
  )
}

export default NuevaSalidaBodega
